window.lazyVideoObserver = null

document.addEventListener("DOMContentLoaded", function () {
  let videos = document.querySelectorAll(".lazy-video")

  window.lazyVideoObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        let video = entry.target
        let sources = video.querySelectorAll("source")

        sources.forEach(source => {
          source.src = source.dataset.src
        })

        video.load()
        window.lazyVideoObserver.unobserve(video)
      }
    })
  }, { threshold: 0.5 })

  videos.forEach(video => window.lazyVideoObserver.observe(video))
})
